import ReactGA from 'react-ga4';

const userProfile = JSON.parse(localStorage.getItem('user_profile'));

export const init = () => {
  ReactGA.initialize([
    {
      trackingId: 'G-8TSSQVDSW6',
      gaOptions: {
        userId: userProfile?.userId
      }
    }
  ]);

  ReactGA.gtag('set', 'user_properties', {
    userid: userProfile?.userId,
    user_org: userProfile?.organization
  });

  window.dataLayer.push({
    user_id: userProfile?.userId
  });
};

export default init;
